import React from 'react';
import View from '../view';
import { marked } from 'marked';

type Props = {
  content: string | null;
};

const MarkDownParser = ({ content }: Props) => {
  return (
    <View className="markdown flex flex-col">
      {content && (
        <View
          dangerouslySetInnerHTML={{
            __html: content
              ? marked.parse(content, {
                  gfm: true,
                  breaks: true,
                })
              : '',
          }}
        />
      )}
    </View>
  );
};
export default MarkDownParser;
